import "../Waste-Dashboard/WasteDashboard.css"
import {AiOutlineArrowDown} from 'react-icons/ai'
import {AiOutlineArrowUp} from 'react-icons/ai'
import SubclassDisplayChart from "./components/SubclassDisplayChart";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import axiosInstance from "../../api/axios";


const SubclassDisplay = ({
                             id,
                             currentWasteItem,
                             dayvalue,
                             language,
                             message2,
                             selectedButton,
                             totalwasteproduced,
                             colorwaste,
                             percentagechange,
                             TotalWasteWeight,
                             datevalue,
                            currentWasteItem_
                         }) => {


     const {t, i18n} = useTranslation();
    const [totalwasteproduceddata, setTotalWasteProducedData] = useState('');
    const [wasteweight, setWasteWeight] = useState(TotalWasteWeight);
    const [colorwastechart, setColorWasteChart] = useState();
    const [percentagechangewastechart, setPercentageChangeWasteChart] = useState();
    const [binpk, setBinPk] = useState();


    useEffect(() => {
        const fetchData = async () => {
            try {
                const binResponse = await axiosInstance.get('/get_bins');
                const foundData = binResponse.data.find(item => item.unique_identifier === id);
                console.log('binPK ', foundData);
                setBinPk(foundData?.id);

                if (foundData?.id) {
                    const wasteResponse = await axiosInstance.get(`/wastebarchart/${foundData.id}/${dayvalue}`, {
                        params: {
                            wasteitem: currentWasteItem_,

                        }
                    });
                    setPercentageChangeWasteChart(parseFloat(wasteResponse.data?.percentage_change).toFixed(2));
                    setColorWasteChart(wasteResponse.data?.color);
                    setTotalWasteProducedData(wasteResponse.data?.objects);
                    setWasteWeight(wasteResponse.data?.waste_weight);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [currentWasteItem_, id, dayvalue]);


    const filterlang = () => {
        if (selectedButton === 'year') {
            return "jaar";
        }

        if (selectedButton === '6months') {
            return "6 maanden";
        }

        if (selectedButton === '3months') {
            return "3 maanden";
        }

        if (selectedButton === 'month') {
            return "maanden";
        }

        if (selectedButton === 'week') {
            return "week";
        }

        if (selectedButton === 'day') {
            return "dag";
        }

        if (selectedButton === 'custom') {
            return "aangepast";
        }
    };

    const translations = {
        day: 'dag',
        week: 'week',
        month: 'maand',
        '3months': '3 maanden',
        '6months': '6 maanden',
        year: 'jaar'
    };

    const translateToDutch = (text) => {
        const translations = {
            "Monday": "Maandag",
            "Tuesday": "Dinsdag",
            "Wednesday": "Woensdag",
            "Thursday": "Donderdag",
            "Friday": "Vrijdag",
            "Saturday": "Zaterdag",
            "Sunday": "Zondag",
            "January": "Januari",
            "February": "Februari",
            "March": "Maart",
            "April": "April",
            "May": "Mei",
            "June": "Juni",
            "July": "Juli",
            "August": "Augustus",
            "September": "September",
            "October": "Oktober",
            "November": "November",
            "December": "December",
            "Organic": "Biologisch",
            "PMD": "PMD",
            "Paper": "papier",
            "Residual": "Resterend",
        };
        return translations[text] || text;
    }

    const translatedSelectedButton = language === "Dutch" ? translations[selectedButton] : selectedButton;
    const message = `Totaal Afval in Vergelijking Met Vorige ${translatedSelectedButton}`;

    return (
        <div
            style={{minHeight: "50vh"}}
            class="bg-white dark:bg-plaex-dark dark:text-white"
        >
            {/* Nav and Side Bar Import */}
            <div className="flex flex-col items-center justify-center w-full mb-4">
                <h2 className="text-2xl font-poppins font-semibold text-center ">
                    {t('subwastecompositionlabel')}
                </h2>
                <div className="flex items-center justify-center gap-4 mt-2">
                        <span className="font-semibold text-base">
                            {totalwasteproduceddata} <span
                            className="font-light">{t('objectslabel')}</span> | {wasteweight}
                            <span className="font-light"> KG</span>
                        </span>
                    <span
                        className={`text-${colorwastechart}-500 flex items-center justify-center text-sm font-semibold`}>
                            {percentagechangewastechart}% {colorwastechart === "red" ?
                        <AiOutlineArrowUp/> :
                        <AiOutlineArrowDown/>}
                        </span>
                </div>
            </div>

            <SubclassDisplayChart id={id} wasteitem={currentWasteItem} dayvalue={dayvalue} datevalue_={datevalue}
                                  selectedButton={selectedButton}/>
        </div>
    );
};

export default SubclassDisplay;

